import { Option } from '@/class/Option';
import Select from '../../../utils/select';
import {
  adminInput,
  adminButtonPrimary,
  adminSectionTitle,
  adminModalPanel,
} from '../../layout/adminStyles';
import React, { FC, FormEvent } from 'react';
import { ItemEditForm } from './editModal';

type Props = {
  isShowModal: boolean;
  form: ItemEditForm;
  categoryOptions: Option[];
  isSaving: boolean;
  onChange: (form: ItemEditForm) => void;
  onClose: () => void;
  onSubmit: () => void;
};

const ItemCreateModal: FC<Props> = ({
  isShowModal,
  form,
  categoryOptions,
  isSaving,
  onChange,
  onClose,
  onSubmit,
}) => {
  if (!isShowModal) {
    return null;
  }

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      role="dialog"
      aria-modal="true"
      aria-labelledby="item-create-modal-title"
    >
      <div className={adminModalPanel}>
        <div className="mb-4 flex items-center justify-between border-b border-stone-200 pb-3">
          <h2 id="item-create-modal-title" className={adminSectionTitle + ' mb-0 border-0 pb-0'}>
            新規商品登録
          </h2>
          <button
            type="button"
            className="text-2xl leading-none text-stone-500 hover:text-stone-800"
            onClick={onClose}
            aria-label="閉じる"
          >
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="create-item-name" className="mb-1 block text-sm font-medium text-stone-700">
              商品名
            </label>
            <input
              id="create-item-name"
              type="text"
              required
              className={`${adminInput} w-full`}
              value={form.item_name}
              onChange={(e) => onChange({ ...form, item_name: e.target.value })}
            />
          </div>

          <div className="mb-4">
            <label htmlFor="create-furigana" className="mb-1 block text-sm font-medium text-stone-700">
              ふりがな
            </label>
            <input
              id="create-furigana"
              type="text"
              className={`${adminInput} w-full`}
              value={form.furigana}
              onChange={(e) => onChange({ ...form, furigana: e.target.value })}
            />
          </div>

          <div className="mb-4">
            <label htmlFor="create-category" className="mb-1 block text-sm font-medium text-stone-700">
              カテゴリ
            </label>
            <Select
              options={categoryOptions}
              value={form.category_id}
              cssClass={`${adminInput} w-full`}
              onChange={(value) => onChange({ ...form, category_id: value })}
            />
          </div>

          <div className="mb-6">
            <label htmlFor="create-level" className="mb-1 block text-sm font-medium text-stone-700">
              レベル
            </label>
            <Select
              options={[
                { id: '1', name: 'LIGHT' },
                { id: '2', name: 'その他' },
              ]}
              value={form.level}
              cssClass={`${adminInput} w-full`}
              onChange={(value) => onChange({ ...form, level: value })}
            />
          </div>

          <div className="flex justify-end gap-2">
            <button
              type="button"
              className="rounded-xl border border-stone-300 px-5 py-2 text-stone-700 hover:bg-stone-50"
              onClick={onClose}
              disabled={isSaving}
            >
              キャンセル
            </button>
            <button type="submit" className={adminButtonPrimary} disabled={isSaving}>
              {isSaving ? '登録中...' : '登録'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ItemCreateModal;
